import type {
	EFFeatureRewardAcquiredEvent,
	EFFeatureRewardAcquiredHandler,
} from "@/features/runtime/FeatureTypes";
import { debugLog, debugWarn } from "@/utils";

export type FeatureEventsSnapshot = {
	rewardSubscriberCount: number;
};

function freezeSnapshot(snapshot: FeatureEventsSnapshot): FeatureEventsSnapshot {
	return Object.freeze({
		rewardSubscriberCount: snapshot.rewardSubscriberCount,
	});
}

export class FeatureEventsBus {
	private readonly rewardHandlers = new Set<EFFeatureRewardAcquiredHandler>();

	public subscribeRewardAcquired(
		handler: EFFeatureRewardAcquiredHandler
	): () => void {
		this.rewardHandlers.add(handler);

		debugLog("[FeatureEventsBus] reward subscriber added", {
			rewardSubscriberCount: this.rewardHandlers.size,
		});

		return () => {
			this.rewardHandlers.delete(handler);

			debugLog("[FeatureEventsBus] reward subscriber removed", {
				rewardSubscriberCount: this.rewardHandlers.size,
			});
		};
	}

	public emitRewardAcquired(event: EFFeatureRewardAcquiredEvent): void {
		debugLog("[FeatureEventsBus] emitRewardAcquired()", {
			rewardSubscriberCount: this.rewardHandlers.size,
			rewardKeys: event.rewardKeys,
		});

		for (const handler of this.rewardHandlers) {
			try {
				handler(event);
			} catch (error) {
				debugWarn("[FeatureEventsBus] reward subscriber failed", error);
			}
		}
	}

	public getSnapshot(): FeatureEventsSnapshot {
		return freezeSnapshot({
			rewardSubscriberCount: this.rewardHandlers.size,
		});
	}
}